import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { Modal, Button } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ errorsArr = [] }) => {
  const { formatMessage } = useIntl()
  const modal = useModal()

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.title)}
    >
      <div className="space-y-4">
        <ul className="list-disc">
          {errorsArr.map((errors) => 
            errors
            .filter((error) => error && error !== '')
            .map((error) =>
              <li>
                <p className='whitespace-pre-wrap'>
                  {error.replaceAll('<br />', '\n')}
                </p>
              </li>
            )
          )}
        </ul>

        <Button
          size="sm"
          onClick={() => modal.remove()}
        >
          Close
        </Button>
      </div>
    </Modal>
  )
})
